export const APPROVE = "approve";
export const REJECT = "reject";

export const REJECTION_PREFIX_IMPERSONATION = "Face match with ";
export const REJECTION_PREFIX_DEVICE_LINKAGES = "Device linkage with ";

export const APPROVE_REJECT_OPTIONS = [
  {
    label: "Approve",
    value: "approve",
  },
  {
    label: "Reject",
    value: "reject",
  },
];

export const AADHAR_REJECT_REASON_OPTIONS = [
  {
    label: "Face not present",
  },
  {
    label: "Invalid - wrong posture/clothes",
  },
  {
    label: "Profile not matching with PAN",
  },
  {
    label: "Profile not matching with Aadhar",
  },
  {
    label: "Wearing headgear, goggles or mask",
  },
  {
    label: "Blur Image",
  },
  {
    label: "Photo of a photo",
  },
];

export const ACTIVE_PROFILE_TAB = "active";
export const TERMINATED_PROFILE_TAB = "terminated";

export const PROFILE_TABS = [
  {
    notPath: TERMINATED_PROFILE_TAB,
    title: "Active profiles",
  },
  {
    path: TERMINATED_PROFILE_TAB,
    title: "Terminated profiles",
  },
];

export const DOCUMENT_VERIFICATION_STEPS = [
  {
    key: "address_doc",
  },
  {
    key: "bank_doc",
  },
  {
    key: "ev_doc",
  },
  {
    key: "license_card_doc",
  },
  {
    key: "pan_card_doc",
  },
];
